// removed by extract-text-webpack-plugin
module.exports = {"bar":"pAkQrSdAQA2ZI1cP14L8-","wrapper":"_3AionJJqJKJT6kVGZtBcFM","content":"_1TNz5gZdgRPytbHRxV1-oD"};


//////////////////
// WEBPACK FOOTER
// ./app/web/src/components/containers/BottomBar.css
// module id = 212
// module chunks = 0